(function () {
    'use strict';
    angular
        .module('josdaviApp')
        .factory('EmploieTemps', EmploieTemps);

    EmploieTemps.$inject = ['$resource'];

    function EmploieTemps($resource) {
        var resourceUrl = 'api/emploie-temps/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
